import defectiveIconSrc from '../../assets/icons/orderStatusIcons/defective.png'
import GenericIcon from './GenericIcon'

const DefectiveIcon = ({ className }) => {
  return <GenericIcon src={defectiveIconSrc} alt="Defective Icon" className={className} />
}

export default DefectiveIcon
